// @flow
import React, { Component } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import styled from "styled-components";
import { initialiseEvents, pageview } from "./utils/events";

import { Page } from "./styled";
import "./App.css";

import homePageView from "./home-page-view";
import PageHeader from "./header-view";
import createStore from "./state";
import BlogDialog from "./blog-dialog";
import PhotoDialog from "./photo-dialog";
import PhotosDialog from "./photos-dialog";
import FeedbackDialog from "./feedback-dialog";
import PlotMapDialog from "./plot-map-dialog";
import WriteJournalDialog from "./write-journal-dialog";
import { fetchUserInfo, fetchSessionInfo } from "./state/context/actions";
import { fetchBlogs } from "./state/blogs/actions";
import { HOME } from "./home-page-view/view";

initialiseEvents();
pageview(HOME);

console.log("env", JSON.stringify(process.env));

const RouterContent = styled.div``;

class App extends Component {
    constructor(props) {
        super(props);

        this.store = createStore();
        this.store.dispatch(fetchUserInfo());
        this.store.dispatch(fetchSessionInfo());
        this.store.dispatch(fetchBlogs());
    }

    render() {
        return (
            <Router>
                <ReduxProvider store={this.store}>
                    <div className="getjealousApp">
                        <BlogDialog />
                        <PhotosDialog />
                        <PhotoDialog />
                        <FeedbackDialog />
                        <PlotMapDialog />
                        <WriteJournalDialog />
                        <PageHeader />
                        <Page>
                            <RouterContent>
                                <Route path="/" component={homePageView} />
                            </RouterContent>
                        </Page>
                    </div>
                </ReduxProvider>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js